import { Component } from "@angular/core";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { LinkButtonComponent } from "@shared/components/atoms/button/link-button/link-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import { LogoComponent } from "@shared/components/atoms/logo/logo.component";

@Component({
  selector: "app-auth-header",
  imports: [IconComponent, LinkButtonComponent, TranslatePipe, LogoComponent],
  templateUrl: "./auth-header.component.html",
  styleUrl: "./auth-header.component.scss",
})
export class AuthHeaderComponent {}
